import config from '@/const/config';
import createInstance from '../http';
const { request } = createInstance(config.personalBaseUrl);

export default {
  getReceiveAddr: params => request.get(`/api/merchant_addr/1.0.0/getReceiveAddr`, { params }), // 获取收获地址列表
  modifyReceiveAddr: params => request.post(`/api/merchant_addr/1.0.0/modifyReceiveAddr`, params), // 添加编辑收货人
  delReceiveAddr: params => request.post(`/api/merchant_addr/1.0.0/delReceiveAddr`, params), // 删除收货人
  getInvoiceDetail: params => request.post(`/api/merchant_invoice/1.0.0/getInvoiceDetail`, params), // 获取发票详情
  modifyInvoice: params => request.post(`/api/merchant_invoice/1.0.0/modifyInvoice`, params), // 编辑发票信息
  getPurchaseAuthDetail: params => request.get(`/api/share-psr-center/1.0.0/getCustomerLoginAccountInfo`, { params }), // 获取认证信息
  getAllQualifies: params => request.get(`/api/merchant_qualifies_auth/1.0.0/getAllQualifies`, { params }), // 获取全部资质
  updateQualify: params => request.post(`/api/merchant_qualifies_auth/1.0.0/updateQualify`, params), // 更新资质
  getUpdateRecord: params => request.get(`/api/merchant_qualifies_auth/1.0.0/getUpdateRecord`, { params }), // 获取资质更新记录
  getQualifyTemplate: params => request.get(`/api/merchant_qualifies_auth/1.0.0/getQualifyTemplate`, { params }), // 获取资质编辑模版
  getUpdateDetail: params => request.get(`/api/merchant_qualifies_auth/1.0.0/getUpdateDetail`, { params }), // 获取资质更新申请详情
  // getPurchaseQualifies: params => request.get(`/api/merchant_qualifies_auth/1.0.0/purchase_qualifies_auth`, { ...params, handleError: true }) // 查询采购资质认证信息
  // 11.15 配合技改
  getPurchaseQualifies: params => request.get(`/api/share-psr-center/1.0.0/getCustomerWithExtByStoreId`, { ...params, handleError: true }), // 查询采购资质认证信息

  // 查询客户详情信息
  getCustomerWithExtByStoreId: (p) => request.get(`/api/share-psr-center/1.0.0/getCustomerWithExtByStoreId`, { params: p }),
};
